var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fields mb-4"},[_c('h4',[_vm._v(_vm._s(_vm.$t('General')))]),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'general_refresh_rate',
        label: 'Refresh rate',
        disabled: false,
        description:
          'Set your refresh rate of the data. Less than rate are, more the dashboard data will up to date. You need to restart this app after change ;)',
        values: _vm.fieldValues('general_refresh_rate'),
        target: 'app'
      },false)),_c('ConfigFieldInput',_vm._b({},'ConfigFieldInput',{
        id: 'general_port',
        label: 'Port',
        disabled: false,
        description: 'Port used by the server',
        target: 'app'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'general_skin_on_load',
        label: 'Default skin loaded',
        disabled: false,
        description: 'Set the skin loaded when this app was started',
        values: _vm.fieldValues('general_skin_on_load'),
        target: 'app'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'general_skin_locale',
        label: 'Langue',
        disabled: false,
        description: 'Choose your locale used on this app',
        values: _vm.fieldValues('general_skin_locale'),
        target: 'app'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'general_job_remaining',
        label: 'Job delivery time',
        disabled: false,
        description: 'Display the due date or the remaining time for a job',
        values: _vm.fieldValues('general_job_remaining'),
        target: 'app'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'general_h-shift-layout',
        label: 'H-Shifter layout',
        disabled: false,
        description:
          'Show the current range of H-Shifter OR the automatic number',
        values: _vm.fieldValues('general_h-shift-layout'),
        target: 'app'
      },false)),_c('ConfigFieldChoice',_vm._b({},'ConfigFieldChoice',{
        id: 'general_damage_accurate',
        label: 'Damage accurate',
        disabled: false,
        description:
          'Show the average with value of \'Damage diagnostic\' or same as the \'Route advisor\'',
        values: _vm.fieldValues('general_damage_accurate'),
        target: 'app'
      },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }